export default {
  'memberAsset.filter.source.all': 'All sources',
  'memberAsset.filter.source.upload': 'Uploaded',
  'memberAsset.filter.source.ai': 'AI generated',
  'memberAsset.filter.dateRange.start': 'Select start date',
  'memberAsset.filter.dateRange.end': 'Select end date',
  'memberAsset.filter.type.all': 'All types',
  'memberAsset.filter.type.text': 'Text',
  'memberAsset.filter.type.image': 'Image',
  'memberAsset.filter.type.video': 'Video',
  'memberAsset.filter.type.audio': 'Audio',
  'memberAsset.empty': 'No assets yet',
  'memberAsset.loadFailed': 'Failed to load assets',
  'memberAsset.loadingMore': 'Loading more…',
  'memberAsset.noMore': 'No more items',
  'memberAsset.preview.title': 'Preview',
  'memberAsset.download': 'Download',
  'memberAsset.downloadFailed': 'Download failed',
  'memberAsset.delete': 'Delete',
  'memberAsset.deleteSuccess': 'Deleted successfully',
  'memberAsset.deleteFailed': 'Delete failed. Please try again.',
};
